import { Link, useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
// assets
import createServiceModal from "../../../../assets/images/softwareGuideImage/sale/createServiceModal.png";
import cashDeskImg from "../../../../assets/images/softwareGuideImage/sale/cashDesk.png";

const SoftwareGuide = () => {
  const { branchId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);

  const tabClick = (tabNumber) => {
    setActiveTab(tabNumber);
    navigate(`/sale/${branchId}/softwareGuide/#${tabNumber}`);
  };

  useEffect(() => {
    const tabNumber = parseInt(window.location.hash.replace("#", ""), 10);
    if (!isNaN(tabNumber) && tabNumber > 0 && tabNumber <= 10) {
      setActiveTab(tabNumber);
    }
  }, []);

  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="bg-white p-2 border border-bottom-1 shadow rounded-3 mb-2">
        <ul className="nav nav-pills">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 1 ? "activeOrderLink" : ""}`}
              href="#section1"
              onClick={() => tabClick(1)}
            >
              تنظیمات پایه شعبه
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 2 ? "activeOrderLink" : ""}`}
              href="#section2"
              onClick={() => tabClick(2)}
            >
              اطلاعات عمومی
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 3 ? "activeOrderLink" : ""}`}
              href="#section3"
              onClick={() => tabClick(3)}
            >
              تعریف خدمات
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 4 ? "activeOrderLink" : ""}`}
              href="#section4"
              onClick={() => tabClick(4)}
            >
              تنظیمات ارسال
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 5 ? "activeOrderLink" : ""}`}
              href="#section5"
              onClick={() => tabClick(5)}
            >
              مدیریت فروش
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 6 ? "activeOrderLink" : ""}`}
              href="#section6"
              onClick={() => tabClick(6)}
            >
              مدیریت کارمندان
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 7 ? "activeOrderLink" : ""}`}
              href="#section7"
              onClick={() => tabClick(7)}
            >
              پوز و پرینتر
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 8 ? "activeOrderLink" : ""}`}
              href="#section8"
              onClick={() => tabClick(8)}
            >
              صندوق
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab === 9 ? "activeOrderLink" : ""}`}
              href="#section9"
              onClick={() => tabClick(9)}
            >
              پیجر
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === 10 ? "activeOrderLink" : ""
              }`}
              href="#section10"
              onClick={() => tabClick(10)}
            >
              میز غذاخوری
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === 11 ? "activeOrderLink" : ""
              }`}
              href="#section11"
              onClick={() => tabClick(12)}
            >
              ثبت سفارش
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === 12 ? "activeOrderLink" : ""
              }`}
              href="#section12"
              onClick={() => tabClick(12)}
            >
              مدیریت سفارش ها
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === 13 ? "activeOrderLink" : ""
              }`}
              href="#section13"
              onClick={() => tabClick(13)}
            >
              لیست آشپزخانه
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === 14 ? "activeOrderLink" : ""
              }`}
              href="#section14"
              onClick={() => tabClick(14)}
            >
              مدیریت پیک‌ها
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === 15 ? "activeOrderLink" : ""
              }`}
              href="#section15"
              onClick={() => tabClick(15)}
            >
              تحویل سفارش
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${
                activeTab === 16 ? "activeOrderLink" : ""
              }`}
              href="#section16"
              onClick={() => tabClick(16)}
            >
              اسنپ
            </a>
          </li>
        </ul>
      </div>
      <div className="bg-white border border-1 rounded-3 px-4 py-3">
        <section className="mb-3 d-flex">
          <Link to={`/sale/${branchId}/#1`} className="link back-link me-1 ">
            <i className="bi bi-arrow-right fs-3"></i>
          </Link>
          <h3>مراحل گام به گام راه اندازی یک شعبه </h3>
        </section>
        <section id="section1" className="">
          <p className="softwareGuidTitle">۱- تنظیمات پایه شعبه</p>
          <div className="text-justify">
            برای شروع، به تنظیمات پایه بروید. در این بخش، گزینه‌هایی برای مدیریت
            و پیکربندی تنظیمات اولیه وجود دارد که می‌توانید با استفاده از آن‌ها،
            عملکرد شعبه را به دلخواه تنظیم کنید. در این قسمت، بر روی دکمه
            "بازنشانی تنظیمات اولیه" کلیک کنید. با این کار، تمام تنظیمات به حالت
            پیش‌فرض بازمی‌گردند.همچنین این گزینه زمانی مفید است که بخواهید تمامی
            تغییرات اعمال شده را لغو کرده و به تنظیمات اولیه بازگردید .در صورت
            نیاز، می‌توانید هر یک از این تنظیمات را ویرایش کرده و بر اساس
            نیازهای خاص شعبه، آن‌ها را تنظیم کنید.
          </div>
          <p className="text-end">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/branchSetting`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section2" className="">
          <p className="softwareGuidTitle">۲- اطلاعات عمومی</p>
          <div className="text-justify">
            دراین قسمت به داشبورد "اطلاعات عمومی" مراجعه کنید. در این بخش،
            اطلاعات پایه و ضروری سیستم را وارد خواهید کرد.این بخش شامل ۳ قسمت
            اصلی "طبقات کالا" ، "واحد های سنجش کالا" ، "کالاها / خدمات" است.
            مراحل زیر را به ترتیب انجام دهید:
            <ol>
              <li>
                تعریف طبقات کالا: در این قسمت، دسته بندی کلی محصولات و خدماتی که
                در سیستم مدیریت می‌کنید را مشخص کنید.
                <br /> مثال:مواد اولیه ، خدمات قابل انجام و کالاهای قابل فروش
                <p className="text-end">
                  <Link
                    className="btn btn-sm btn-outline-purple"
                    to={`/baseinfo/${branchId}/productcategory`}
                  >
                    مشاهده بخش
                    <i className="bi bi-arrow-left"></i>
                  </Link>
                </p>
              </li>
              <li className="my-5">
                تعریف واحدهای سنجش: واحدهای اندازه‌گیری مختلفی که برای کالاها و
                خدمات خود استفاده می‌کنید را در این قسمت تعریف کنید.
                <br />
                مثال: عدد، کیلوگرم، لیتر، متر، ساعت (بر اساس واحد، وزن، حجم و
                ...) را انتخاب کنید.همچنین نحوه قیمت‌گذاری خود را تعیین کنید.
                <p className="text-end mt-3">
                  <Link
                    className="btn btn-sm btn-outline-purple"
                    to={`/baseinfo/${branchId}/unitmeasurements`}
                  >
                    مشاهده بخش
                    <i className="bi bi-arrow-left"></i>
                  </Link>
                </p>
              </li>
              <li>
                تعریف کالاها و خدمات: در این مرحله، تمامی کالاها و خدماتی که
                ارائه می‌دهید را به همراه جزئیات کامل ثبت کنید.
                <br /> مثال: هزینه‌بسته‌بندی ، هزینه‌ارسال ، چلوجوجه کباب
                ،نوشابه ،...
                <p className="text-end">
                  <Link
                    className="btn btn-sm btn-outline-purple"
                    to={`/baseinfo/${branchId}/product`}
                  >
                    مشاهده بخش
                    <i className="bi bi-arrow-left"></i>
                  </Link>
                </p>
              </li>
            </ol>
          </div>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section3" className="">
          <p className="softwareGuidTitle">۳- تعریف خدمات</p>
          <p>
            در این مرحله، به قسمت تنظیمات بروید و سپس "تعریف خدمات" را انتخاب
            کنید. در این بخش، خدمات مختلفی که در فاکتورها نمایش داده می‌شوند، از
            جمله هزینه ارسال، هزینه بسته‌بندی و حق سرویس را تعریف کنید. این
            هزینه‌ها باید به‌گونه‌ای تنظیم شوند که منعکس‌کننده خدمات ارائه‌شده
            به مشتریان باشند.
          </p>
          <div className="row text-justify">
            <div className="col-6 justify-content-center align-content-start">
              <p>
                برای ایجاد خدمت جدید، روی دکمه "سرویس جدید" کلیک کنید. یک پنجره
                باز می‌شود :
              </p>
              <div>
                <ul className="SoftwareGuidUl">
                  <li>
                    این پنجره شامل یک فیلد انتخاب خدمت است. این فیلد شامل تمامی
                    خدماتی است که قبلاً در قسمت کالاها تعریف کرده‌اید. مانند
                    هزینه‌ارسال ،هزینه‌بسته‌ی‌بندی ، ... .
                    <br /> برای هر خدمت می‌توانید هزینه مربوط به آن را وارد
                    کنید.
                  </li>
                  <li>
                    برای تشخیص خدمات در فروش باید از میان گزینه‌های تعریف در
                    فروش یک گزینه را انتخاب کنید.
                  </li>
                  <li>
                    وضعیت هر یک از سه گزینه: "معاف از مالیات" ، "نمایش در
                    فاکتور" ، "وضعیت" را می‌توانید با توجه به سیستم خود، به‌طور
                    دلخواه فعال یا غیرفعال کنید.
                  </li>
                  <li>
                    {" "}
                    در قسمت توضیحات نیز می‌توانید توضیحات مربوط به خدمت را
                    یادداشت کنید.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-6 justify-content-center align-content-start">
              <img
                src={createServiceModal}
                alt="createnewservice"
                className="img-fluid border p-1"
              />
            </div>
          </div>
          <p className="text-end mt-3">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/serviceSetting`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section4" className="">
          <p className="softwareGuidTitle">۴- تنظیمات ارسال</p>
          <div className="text-justify">
            در این مرحله به "تنظیمات ارسال" مراجعه کنید. مناطقی که خدمات ارسال
            به آن‌ها ارائه می‌دهید را مشخص کنید و برای هر محله، نام و هزینه
            ارسال را تعیین کنید.
          </div>
          <p className="text-end">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/shipmentManger`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section5" className="">
          <p className="softwareGuidTitle">۵- مدیریت فروش</p>
          <div className="text-justify">
            به منظور مدیریت موثر فروش، به قسمت "مدیریت فروش" رفته و اطلاعات
            مربوط به بخش‌های فروش و منوها را به ترتیب وارد کنید. این اطلاعات به
            شما کمک می‌کند تا فروش خود را بهتر سازماندهی کنید.
            <ol>
              <li>
                ایجاد بخش فروش: ابتدا در قسمت "مدیریت فروش"، "بخش فروش" با
                استفاده از دکمه "بخش جدید"، بخش فروش خود را ایجاد کنید.
                <br />
                <p className="text-end mt-3">
                  <Link
                    className="btn btn-sm btn-outline-purple mx-auto"
                    to={`/sale/${branchId}/saleunits`}
                  >
                    مشاهده بخش
                    <i className="bi bi-arrow-left"></i>
                  </Link>
                </p>
              </li>
              <li>
                ایجاد دسته‌بندی‌ها: سپس در قسمت منوهای فروش، بخش فروش خود را
                انتخاب کرده و با استفاده از دکمه "دسته‌بندی جدید"، دسته‌بندی‌های
                خود را بسازید. مثال: غذای اصلی، نوشیدنی.
                <p className="text-end mt-1">
                  <Link
                    className="btn btn-sm btn-outline-purple mx-auto"
                    to={`/sale/${branchId}/selectUnit`}
                  >
                    مشاهده بخش
                    <i className="bi bi-arrow-left"></i>
                  </Link>
                </p>
              </li>
              <li>
                ایجاد زیردسته‌ها:با کلیک بر روی عنوان هر دسته وارد زیردسته مربوط
                به آن دسته می‌شوید سپس با انتخاب گزینه "زیردسته جدید"، می‌توانید
                زیردسته‌های جدیدی برای منوی خود بسازید. برای مثال: نوشیدنی‌های
                گرم، نوشیدنی‌های سرد.
              </li>
              <li>
                اضافه کردن آیتم‌ها به منو: در قسمت منو، می‌توانید منوهای مورد
                نظر خود را اضافه کنید مثال: در زیردسته "نوشیدنی‌های گرم"
                می‌توانید منوهای "قهوه"، "چای" را تعریف کنید..
              </li>
            </ol>
            توجه: به یاد داشته باشید که نمی‌توانید همزمان برای یک دسته‌بندی هم
            منو و هم زیردسته اضافه کنید.
          </div>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section6" className="">
          <p className="softwareGuidTitle">۶- مدیریت کارمندان</p>
          <div className="text-justify">
            برای مدیریت بهتر کارمندان و تخصیص وظایف به آن‌ها، مراحل زیر را دنبال
            کنید:
            <ol>
              <li>
                ورود به بخش مدیریت کارمندان: به بخش "مدیریت کارمندان" و سپس به
                قسمت کارمندان شعبه در سیستم خود مراجعه کنید.
              </li>
              <li>
                تعریف کارمندان: اطلاعات شخصی هر کارمند (نام، نام خانوادگی، شماره
                تماس، ...) را وارد کنید.
              </li>
              <li>
                تخصیص نقش‌ها: با کلیک بر روی دکمه مدیریت نقش‌ها به هر کارمند،
                نقش یا نقش‌هایی که بر عهده دارد را اختصاص دهید . مثال: پیک،
                گارسون، صندوقدار
              </li>
            </ol>
            بعد از انجام این مرحله میتوانید کاربر خود را به صندوق اختصاص دهید.
          </div>
          <p className="text-end">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/employee`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section7" className="">
          <p className="softwareGuidTitle">۷- پوز و پرینتر </p>
          <div className="text-justify">
            <div>
              <p className="mb-1" style={{ fontWeight : "bold" }}>توجه :</p>
            <span>
              قبل از راه‌اندازی دستگاه پوز، لازم است هماهنگی‌های لازم با
              بانک مربوطه انجام شود. هر زمان که دستگاه پوز جدیدی به مجموعه اضافه
              می‌شود، لازم است حتماً در نرم‌افزار ثبت و تعریف گردد. همچنین پس از
              ثبت، دستگاه پوز باید به یکی از صندوق‌ها یا کارمند مربوطه اختصاص
              داده شود تا امکان استفاده و مدیریت صحیح آن فراهم گردد.
            </span>
            </div>
            
            <br />
            <br />
            در این قسمت ، به بخش "دستگاه و صندوق" در سیستم خود مراجعه کنید و
            تنظیمات مربوط به صندوق، پایانه فروش (پوز)، پرینتر، و سایر
            نیازمندی‌ها را انجام دهید.
            <p className="fw-bold">راهنمای تنظیم دستگاه پوز</p>
            <ol className="SoftwareGuidUl">
              <li>
                ورود به بخش بانک‌ها: در این بخش، اطلاعات مربوط به بانک‌هایی که
                با آن‌ها همکاری می‌کنید را وارد نمایید.
              </li>
              <li>
                {" "}
                اضافه کردن دستگاه پوز : روی دکمه "پوز جدید" کلیک کنید. یک پنجره
                جدید باز می‌شود که شامل اطلاعات زیر است:
                <ul className="SoftwareGuidUl">
                  <li>
                    سرویس‌دهنده: همان بانکی که اطلاعات آن را وارد کرده‌اید.
                  </li>
                  <li>نوع پوز: ثابت یا سیار.</li>
                  <li>نوع اتصال: LAN، COM، یا اینترنت.</li>
                  <li>
                    شناسه و شماره ترمینال: اطلاعات مربوط به ترمینال پوز موردنظر.
                  </li>
                </ul>
              </li>
            </ol>
            <p className="text-end">
              <Link
                className="btn btn-sm btn-outline-purple"
                to={`/sale/${branchId}/posDevices`}
              >
                مشاهده بخش
                <i className="bi bi-arrow-left"></i>
              </Link>
            </p>
          </div>
          <div>
            <p className="fw-bold">راهنمای تنظیم پرینتر</p>
            <div>
              برای اضافه کردن پرینتر جدید، روی دکمه "پرینتر جدید" کلیک کنید و در
              صفحه جدید، مشخصات مربوطه را وارد کنید تا پرینترهای خود را به سیستم
              متصل کنید.
            </div>
            <p className="text-end">
              <Link
                className="btn btn-sm btn-outline-purple"
                to={`/sale/${branchId}/printer`}
              >
                مشاهده بخش
                <i className="bi bi-arrow-left"></i>
              </Link>
            </p>
          </div>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section8" className="">
          <p className="softwareGuidTitle">۸- صندوق</p>
          <div className="text-justify">
            برای ساخت و مدیریت صندوق‌های خود، مراحل زیر را دنبال کنید:
            <ol>
              <li>
                ایجاد صندوق جدید: با کلیک بر روی دکمه "صندوق جدید"، صندوق‌های
                خود را ایجاد کنید. برای مثال: "صندوق 1" یا "صندوق کافه".{" "}
              </li>
              <li>
                پس از ایجاد صندوق جدید، برای هر صندوق پنج بخش اصلی وجود دارد:
                <ul className="SoftwareGuidUl">
                  <li>
                    مشاهده وضعیت صندوق: در ستون وضعیت، می‌توانید وضعیت فعال یا
                    غیرفعال بودن صندوق خود را مشاهده کنید.
                  </li>
                  <li>
                    کاربر صندوق: با کلیک بر روی این دکمه، وارد صفحه تخصیص
                    صندوقدار می‌شوید. در این صفحه، با کلیک بر روی دکمه "تخصیص
                    صندوقدار"، لیستی از صندوقداران نمایش داده می‌شود. با کلیک بر
                    روی دکمه "افزودن"، می‌توانید هر کدام از صندوقداران را به
                    صندوق مورد نظر تخصیص دهید.
                  </li>
                  <li>
                    پوزها: با کلیک بر روی این دکمه، وارد صفحه تخصیص پوز می‌شوید.
                    در این صفحه، با کلیک بر روی دکمه "تخصیص پوز"، لیستی از
                    دستگاه‌های پوز نمایش داده می‌شود. با کلیک بر روی دکمه
                    "افزودن"، می‌توانید هر کدام از پوزها را به صندوق مورد نظر
                    تخصیص دهید.
                  </li>
                  <li>
                    بستن صندوق: با کلیک بر روی این دکمه، وارد صفحه عملکرد صندوق
                    می‌شوید. در این صفحه، با کلیک بر روی دکمه "بستن یا بازکردن
                    صندوق"، می‌توانید صندوق خود را فعال یا غیرفعال کنید و گزارش
                    مالی پوز را مشاهده کنید.
                  </li>
                  <li>
                    پرینتر صندوق: با کلیک بر روی این دکمه، وارد صفحه تخصیص
                    پرینتر می‌شوید. در این صفحه، با کلیک بر روی دکمه "تخصیص
                    پرینتر"، لیستی از پرینترها نمایش داده می‌شود. با کلیک بر روی
                    دکمه "افزودن"، می‌توانید هر پرینتری را به صندوق مورد نظر
                    تخصیص دهید.
                  </li>
                </ul>
              </li>
            </ol>
          </div>
          <img src={cashDeskImg} alt="cashDeskImg" className="img-fluid" />
          <p className="text-end">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/cashDeskManage`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section9" className="">
          <p className="softwareGuidTitle">۹- پیجر</p>
          <div className="text-justify">
            برای اضافه کردن پیجرهای جدید به سیستم، به صفحه پیجرها بروید و روی
            دکمه "پیجر جدید" کلیک کنید. فرمی برای وارد کردن اطلاعات پیجر باز
            می‌شود که شامل اطلاعات مورد نیاز مانند:
            <ul>
              <li>
                <ul className="SoftwareGuidUl">
                  <li> کد پیجر: شماره منحصر به فرد پیجر</li>
                  <li>
                    {" "}
                    نام پیجر: نامی برای شناسایی پیجر (مثلاً: پیجر آشپزخانه)
                  </li>
                </ul>
              </li>
            </ul>
            <p>
              وضعیت پیجر: از طریق ستون وضعیت، می‌توانید پیجر را فعال یا غیرفعال
              کنید.{" "}
            </p>
          </div>
          <p className="text-end">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/pager`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section10" className="">
          <p className="softwareGuidTitle">۱۰- میز غذاخوری</p>
          <div className="text-justify">
            برای اضافه کردن میزهای غذاخوری به سیستم،به صفحه میزغذاخوری بروید و
            مراحل زیر را دنبال کنید: روی دکمه "میز جدید" کلیک کنید. فرمی برای
            وارد کردن اطلاعات میز باز می‌شود
            <ul className="SoftwareGuidUl">
              <li>
                نام میز: نامی برای شناسایی میز (مثلاً: میز 1، میز وی آی پی).
              </li>
              <li> شماره میز: شماره منحصر به فرد میز .</li>
              <li>ظرفیت میز: تعداد نفراتی که می‌توانند روی میز بنشینند .</li>
              <li>بخش میز:بخشی که میز در آن قرار می‌گیرد.</li>
            </ul>
          </div>
          <p className="text-end">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/diningtable`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section11" className="">
          <p className="softwareGuidTitle">۱۱- ثبت سفارش</p>
          <div className="text-justify">
            <ol>
              <li>
                انتخاب بخش فروش و صندوق:
                <br />
                ابتدا باید بخش فروش خود را انتخاب کنید. با این انتخاب،
                دسته‌بندی‌ها و منوهای مربوط به هر بخش نمایش داده می‌شوند. سپس از
                لیست صندوق‌ها، صندوق مورد نظر را انتخاب کنید و نوع سفارش (مانند
                بیرون‌بر، سالن و...) را تعیین کنید.
              </li>
              <li>
                نمایش سفارشات جاری:
                <br />
                در بخش "سفارش‌های جاری"، لیستی از تمام سفارش‌هایی که در حال حاضر
                در هر صندوق ثبت شده‌اند، نمایش داده می‌شود.{" "}
              </li>
              <li>
                مشتری:
                <ul className="SoftwareGuidUl">
                  <li>
                    ثبت مشتری جدید: با کلیک بر روی دکمه "ثبت مشتری جدید"،
                    می‌توانید در پنجره باز شده مشخصات مشتری را وارد کرده و سپس
                    بر روی دکمه ثبت و ذخیره کلیک کنید.
                  </li>
                  <li>
                    جستجوی مشتری: با کلیک بر روی "جستجوی مشتری"، پنجره‌ای به نام
                    "مدیریت مشتری" باز می‌شود که لیستی از مشتریان را نمایش
                    می‌دهد. برای هر مشتری دو گزینه وجود دارد:
                    <ol>
                      <li>
                        مشاهده سفارش‌های قبلی: این گزینه اطلاعات سفارشات قبلی
                        مشتری و امکان انتخاب مجدد سه سفارش آخر را نمایش می‌دهد.
                      </li>
                      <li>
                        انتخاب مشتری: با انتخاب این گزینه، اطلاعات مشتری به صورت
                        خودکار در فرم ثبت سفارش بارگذاری می‌شود.
                      </li>
                    </ol>
                  </li>
                  <li>
                    گزینه "همون همیشگی": این گزینه تمامی سفارشات پرتکرار مشتری
                    را همراه با امکان انتخاب مجدد سفارش‌های قبلی نمایش می‌دهد.
                  </li>
                  <li>
                    نکات مهم:
                    <ul className="SoftwareGuidUl">
                      <li>
                        امکان ثبت سفارش هم برای مشتریان ثبت شده و هم برای
                        مشتریان جدید و هم بدون مشتری وجود دارد.
                      </li>
                      <li>
                        با وارد کردن شماره تلفن مشتری در فرم ثبت سفارش و سپس
                        کلیک بر روی "جستجوی مشتری"، پنجره مدیریت مشتری نمایش
                        داده می‌شود.
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                انتخاب منوها:
                <br />
                منوهای مورد نظر خود را از منوهای مربوط به هر بخش انتخاب کنید.
              </li>
              <li>
                پرداخت و ذخیره سفارش:
                <br />
                پس از انتخاب منوهای مورد نظر برای سفارش، بر روی دکمه "ذخیره"
                کلیک کنید. سپس با کلیک بر روی دکمه پرداخت در پنجره پرداخت ،"نوع
                پرداخت" (مانند کارتخوان، نقدی، نقدی و کارتخوان، کارت به کارت،
                اعتباری) را انتخاب کرده و در نهایت بر روی دکمه "پرداخت" کلیک
                کنید. با کلیک بر روی دکمه "چاپ"، امکان چاپ فاکتور فراهم می‌شود.
              </li>
              <li>
                اصلاح سفارش:
                <br />
                اگر سفارشی نیاز به اصلاح دارد، با کلیک بر روی "ارسال اصلاحات به
                آشپزخانه"، در پنجره باز شده شماره فاکتور و توضیحات را وارد کنید.
              </li>
              <li>
                دکمه‌های پایین صفحه:
                <br />
                <ul className="SoftwareGuidUl">
                  <li>
                    حذف: تمام اطلاعات مربوط به سفارش قبلی پاک شده و صفحه برای
                    ثبت سفارش جدید آماده می‌شود.
                  </li>
                  <li>
                    آشپزخانه: سفارش به آشپزخانه ارسال شده و آماده پخت می‌شود.
                  </li>
                  <li>
                    پرداخت: پنجره پرداخت که در بالا توضیح داده شد، باز می‌شود.
                  </li>
                  <li>
                    پرینتر: دارای دو گزینه برای چاپ فاکتور صندوق و چاپ فاکتور
                    آشپزخانه.
                  </li>
                </ul>
              </li>
            </ol>
          </div>
          <p className="text-end">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/submitOrder/0`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section12" className="">
          <p className="softwareGuidTitle">۱۲- مدیریت سفارش ها</p>
          <div className="text-justify">
            در این قسمت، وضعیت تمام سفارشات ، قابل مشاهده و ویرایش است:(رنگ‌های
            مختلف نشان‌دهنده وضعیت‌های مختلف سفارش هستند.)
            <ul className="SoftwareGuidUl">
              <li>جاری: سفارشی که ثبت شده است.</li>
              <li>در حال پخت: سفارشی که در آشپزخانه در حال آماده‌سازی است.</li>
              <li>اتمام پخت: سفارشی که آماده تحویل است.</li>
              <li>
                تحویل پیک/گارسون/مشتری: سفارشی که به پیک، گارسون یا مشتری تحویل
                داده شده است.
              </li>
              <li>برگشتی: سفارشی که برگشت خورده است.</li>
              <li>لغو شده: سفارشی که لغو شده است.</li>
            </ul>
          </div>
          <p className="text-end">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/orderManagment`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section13" className="">
          <p className="softwareGuidTitle">۱۳- لیست آشپزخانه</p>
          <div className="text-justify">
            در این قسمت، تمامی سفارشاتی که در وضعیت "در حال پخت" هستند، نمایش
            داده می‌شوند. همچنین، امکان فیلتر کردن سفارش‌ها بر اساس نوع آن‌ها
            وجود دارد. برای هر سفارش، دو گزینه "عودت به صندوقدار" (در صورت وجود
            مشکل در فاکتور) و "تکمیل پخت" وجود دارد.
          </div>
          <p className="text-end mt-4">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/kitchenList`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section14" className="">
          <p className="softwareGuidTitle">۱۴- مدیریت پیک‌ها</p>
          <div className="text-justify">
            پس از تعریف کارمندان در بخش "مدیریت کارمندان/کارمندان شعبه"، در صورت
            تخصیص نقش پیک به یک کارمند، نام او در این قسمت نمایش داده می‌شود.
            برای هر پیک، دو گزینه موجود است:
            <ul className="SoftwareGuidUl">
              <li>
                تسویه حساب: با کلیک بر روی این گزینه، وارد صفحه فاکتورهای پیک
                می‌شوید که در آن لیست تمام فاکتورهای پیک نمایش داده می‌شود و
                امکان ثبت سند تسویه حساب نیز وجود دارد.
              </li>
              <li>
                تخصیص پوز: با کلیک بر روی این دکمه، وارد صفحه تخصیص پوز می‌شوید
                که لیستی از تمام پوزهای تخصیص داده شده به پیک را مشاهده خواهید
                کرد. امکان حذف هر پوز و تخصیص پوزهای جدید با کلیک بر روی دکمه
                "تخصیص پوز" وجود دارد.{" "}
              </li>
            </ul>
            برای هر پیک، یک پنل جداگانه وجود دارد که با ورود به آن، می‌تواند
            لیست سفارشات خود را مشاهده کند.
          </div>
          <p className="text-end mt-4">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/deliverySettlement`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section15" className="">
          <p className="softwareGuidTitle">۱۵- تحویل سفارش</p>
          <div className="text-justify">
            بسته به نوع سفارش (بیرون‌بر، سالن و...)، امکان تحویل سفارش به پیک یا
            گارسون وجود دارد. برای هر سفارش، با کلیک بر روی دکمه مورد نظر (مثلاً
            "تحویل به پیک")، لیستی از پیک‌ها نمایش داده می‌شود و می‌توانید پیک
            مورد نظر را انتخاب کنید. این فرآیند برای گارسون نیز مشابه است.
          </div>
          <p className="text-end mt-4">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/deliveryOrder`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
        <hr className="mx-5 my-4"></hr>
        <section id="section16" className="">
          <p className="softwareGuidTitle">۱۶- اسنپ</p>
          <div className="text-justify">
            <ol>
              <li>
                تعریف تنظیمات اسنپ : به بخش "فروش" در سیستم خود بروید. در قسمت
                تنظیمات اسنپ، اطلاعاتی که از اسنپ گرفته‌اید را برای هر بخش به
                صورت جداگانه وارد کنید.
              </li>
              <li>
                تعریف هزینه‌های اسنپ
                <ol>
                  <li>به قسمت "تنظیمات" و سپس "تنظیمات اسنپ" بروید.</li>
                  <li>گزینه "تعریف هزینه‌های اسنپ" را انتخاب کنید.</li>
                  <li>
                    هزینه‌های مورد نیاز مانند هزینه‌ارسال ، هزینه‌بسته‌بندی،...
                    را در این قسمت وارد کنید.
                  </li>
                </ol>
              </li>
              <li>
                ایجاد دسته بندی و منو
                <ol>
                  <li>
                    بخش فروشی که می‌خواهید برای آن تنظیمات را انجام دهید، انتخاب
                    کنید.{" "}
                  </li>
                  <li>روی گزینه "ایجاد دسته بندی" کلیک کنید. </li>
                  <li>
                    دسته بندی‌های مختلف محصولات یا خدمات خود را تعریف کنید
                    (مثلاً غذاهای ایرانی، فست فود).
                  </li>
                  <li>
                    برای هر دسته بندی، منوهای مربوطه را ایجاد کنید (مثلاً در
                    دسته بندی غذاهای ایرانی، منوهایی مثل کباب، جوجه و ...).
                  </li>
                </ol>
              </li>
              <li>
                نکات مهم در زمان حذف منو، محصول یا تاپینگ:
                <ol>
                  <li>
                    قبل از انجام هرگونه حذف در نرم‌افزار، لازم است وضعیت اکانت اسنپ‌ فود بررسی و هماهنگی لازم با تیم پشتیبانی اسنپ انجام شود.
                  </li>
                  <li>
                    برای محصولات و منوها:
                    <br />
                    ابتدا آیتم‌های موردنظر باید از اکانت اسنپ حذف شوند. پس از تأیید حذف در اسنپ، می‌توانید همان آیتم‌ها را از نرم‌افزار پاک کنید.
                  </li>
                  <li>
                    برای تاپینگ‌ها:
                    <br />
                    قبل از حذف تاپینگ از نرم‌افزار، باید ریلیشن‌های مرتبط با آن در اسنپ حذف شوند (ارتباط بین تاپینگ و محصولات). پس از اطمینان از حذف ریلیشن‌ها در اسنپ، تاپینگ موردنظر را از نرم‌افزار پاک کنید.
                  </li>
                  <li>
                    انجام حذف بدون هماهنگی با اسنپ ممکن است باعث بروز مغایرت بین منوی نرم‌ افزار و منوی ثبت‌ شده در اسنپ‌فود شود.
                  </li>
                </ol>
              </li>
            </ol>
          </div>
          <p className="text-end mt-4">
            <Link
              className="btn btn-sm btn-outline-purple"
              to={`/sale/${branchId}/snappManager`}
            >
              مشاهده بخش
              <i className="bi bi-arrow-left"></i>
            </Link>
          </p>
        </section>
      </div>
      <div style={{ right: "95%" }} className="pushData">
        <button
          type="button"
          className="btn btn-purple position-relative rounded-circle"
          onClick={() => {
            backToTop();
          }}
        >
          <i className="bi bi-arrow-up fs-5 fw-bold"></i>
        </button>
      </div>
    </>
  );
};

export default SoftwareGuide;
